<div class="row">
  <div class="col-md-12">
    <form>
      <div class="form-group mt-2">
        <input
          type="text"
          class="form-control"
          [formControl]="searchTerm"
          name="username"
          placeholder="Github Username..."
          />
      </div>
    </form>
  </div>
</div>
@if (user() && searchTerm.value) {
  <div class="mt-1">
    <div class="card">
      <h3 class="card-header">
        <strong>{{ user().name }}</strong>
      </h3>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <a href="{{ user().html_url }}">
              <img
                src="{{ user().avatar_url }}"
                class="img-thumbnail github-avatar"
                />
            </a>
          </div>
          <div class="col-md-8">
            <div class="stats">
              <span class="badge badge-primary"
                >{{ user().public_repos }} Public Repos</span
                >
                <span class="badge badge-secondary"
                  >{{ user().public_gists }} Public Gists</span
                  >
                  <span class="badge badge-success click">
                    <a [routerLink]="[user().login, 'followers']" class="fol"
                      >{{ user().followers }} Followers</a
                      >
                    </span>
                    <span class="badge badge-info"
                      >{{ user().following }} Following</span
                      >
                    </div>
                    <div class="list-group mt-3">
                      <div class="list-group-item">
                        <strong>Username: </strong>{{ user().login }}
                      </div>
                      <div class="list-group-item">
                        <strong>Location: </strong>{{ user().location }}
                      </div>
                      <div class="list-group-item">
                        <strong>Email: </strong>{{ user().email }}
                      </div>
                      <div class="list-group-item">
                        <strong>Blog: </strong>{{ user().blog }}
                      </div>
                      <div class="list-group-item">
                        <strong>Member Since: </strong>{{ user().created_at | date }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mt-3">
              <div class="card-header">Repos</div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    @for (repo of repos(); track repo) {
                      <div>
                        <div class="row">
                          <div class="col-md-9">
                            <h5>
                              <a href="{{ repo.html_url }}" target="_blank">{{
                                repo.name
                              }}</a>
                            </h5>
                          </div>
                          <div class="col-md-3">
                            <span class="badge badge-secondary"
                              >{{ repo.watchers }} Watchers</span
                              >
                              <span class="badge badge-primary"
                                >{{ repo.forks }} Forkers</span
                                >
                              </div>
                            </div>
                            <hr />
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            } @else {
            }

